// import { faCircleCheck, faTruck } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState, useMemo } from "react";
import { COLOR_APP, COMPLETED } from "../../../constants";
import { calculateRoundedValue, convertPriceWithCommission, imageRender, numberFormat, thousandSeperate } from "../../../helpers";
import HorizontalRule from "../../../constants/HorizontalRule";
import BillDegitalLogicstics from "../../../components/bill.orderGroups/BillDegitalLogicstics";
import { useLazyQuery } from "@apollo/client";
import { ORDER_DELIVERY_DETAIL } from "../../../graphql/orderDelivery/query";
import _ from "lodash";
// import { FaBabyCarriage } from "react-icons/fa";

// import { Button } from "react-bootstrap"

const FinishOrder = ({ orderData, shopRate, taxPrice }) => {
  const [dataTracking, setDataTracking] = useState();
  const rate = useMemo(() => {
    if (orderData?.rate) {
      return JSON.parse(orderData?.rate);
    }
    return {}
  }, [orderData]);

  // console.log("logs orderData: ", orderData)

  const sumPrice = useMemo(() => {
    return numberFormat(calculateRoundedValue(orderData?.sumPrice / 1000) * 1000)
  }, [orderData]);

  const [getOrderDeliveryDetail, { data: orderDeliveryDetail, loading: loadingOrderDelivery }] = useLazyQuery(ORDER_DELIVERY_DETAIL, { fetchPolicy: "cache-and-network" })

  useEffect(() => {
    if (orderData?.isPaymented) {
      fetchOrderDetailOfDelivery(orderData?.id)
    }
  }, [orderData])



  useEffect(() => {
    if (orderDeliveryDetail) {
      setDataTracking(orderDeliveryDetail?.orderDeliveryOrderGroupId?.data)
    }
  }, [orderDeliveryDetail])



  // fetch order delivery detail
  const fetchOrderDetailOfDelivery = async (id) => {
    try {
      if (loadingOrderDelivery) return;
      await getOrderDeliveryDetail({
        variables: {
          where: {
            orderGroupId: id,
          }
        }
      })

    } catch (error) {
      console.error({ error })
    }
  }


  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
      {!orderData?.isPaymented &&
        <>
          <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
            <div style={{ fontWeight: 'bold', marginRight: 5, color: !orderData?.isPaymented ? "red" : "green" }}>{!orderData?.isPaymented ? "ສະຖານະອໍເດີ້" : "ຊຳລະເງິນແລ້ວ"}</div>
          </div>
          <HorizontalRule height={15} borderType="dashed" />
        </>
      }
      <BillDegitalLogicstics dataTracking={dataTracking} loadingOrderDelivery={loadingOrderDelivery} />

      <div style={{ borderRadius: 10, width: '100%', padding: 10, margin: '10px 0', background: '#FFF' }}>
          <h5>ລາຍລະອຽດສິນຄ້າ</h5>
        <HorizontalRule height={15} borderType="dashed" />


        {(!_.isEmpty(orderData?.dataConfirmCod) && orderData?.status !== "COMPLETED") && <h4 style={{ color: 'red', textAlign: 'center', marginTop: 8 }}>"ຈ່າຍເງິນປາຍທາງ"</h4>}

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>ຊື່ລູກຄ້າ: </div>
          <div style={{ fontSize: 18, fontWeight: 'bold' }}>{dataTracking?.receiver?.fullName ?? orderData?.customerName ?? orderData?.cfName}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>ເບີໂທ: </div>
          <div style={{ fontSize: 18, fontWeight: 'bold' }}>{orderData?.phone}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>ເລກບິນສັ່ງຊື້ </div>
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{orderData?.code}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>ວັນທີ່ສັ່ງຊື້: </div>
          <div style={{ fontSize: 14, fontWeight: 'bold' }}>{moment(orderData?.createdAt).format('DD/MM/YYYY HH:mm')}</div>
        </div>
        {!dataTracking?.deliveryTackingNo &&
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>ຂົນສົ່ງ: </div>
            <div style={{ fontSize: 14, fontWeight: 'bold' }}>{orderData?.logistic ?? orderData?.addressCf}</div>
          </div>
        }
        <HorizontalRule height={15} borderType="dashed" />
        <div style={{ fontWeight: 'bold', fontSize: 20, color: COLOR_APP, marginRight: 5 }}>ລາຍການສິນຄ້າ</div>
        {
          orderData?.orders?.map((order) => {
            return <div>
              <div style={{ display: 'flex' }}>
                <img src={imageRender(order?.liveStock?.stock?.image?.[0] ?? order?.postStock?.stock?.image?.[0] ?? order?.liveStock?.stock?.image ?? order?.postStock?.stock?.image)} style={{ maxWidth: 60, height: "10vw", marginTop: 10, marginRight: 10, height: "auto", borderRadius: 5 }} />
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>
                  <div style={{ fontWeight: 'bold' }}>{order?.productName} {order?.cfMessage ? " (" + order?.cfMessage + ")" : ""}</div>
                  <div>{thousandSeperate(order?.price) + " " + order?.currency + " x" + order?.amount}</div>
                </div>
              </div>
              {/* <div style={{ width: '100%', margin: '5px 0px', height: 0.2, margin: "5px 0px", background: "#EEE" }} /> */}
            </div>
          })
        }

        <div style={{ display: 'flex', fontWeight: 'bold', justifyContent: 'space-between', marginTop: 10 }}>
          <h6>ລວມຈຳນວນ</h6>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>{thousandSeperate(orderData?.amount)}</div>
        </div>
        <div style={{ display: 'flex', fontWeight: 'bold', justifyContent: 'space-between', marginBottom: 6 }}>
          <h6>ລວມເງິນກີບ</h6>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>₭{thousandSeperate(orderData?.totalPrice)}</div>
        </div>
        {orderData?.sumPriceBaht > 0 &&
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <h6>ລວມເງິນບາດ</h6>
            <div style={{ fontWeight: 'bold', fontSize: 18 }}>฿{thousandSeperate(orderData?.sumPriceBaht)}</div>
          </div>
        }
        {orderData?.sumPriceUsd > 0 &&
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h6>ລວມເງິນໂດລາ</h6>
            <div style={{ fontWeight: 'bold', fontSize: 18 }}>${thousandSeperate(orderData?.sumPriceUsd)}</div>
          </div>
        }
         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: 20, fontWeight: 'bold' }}>ເງິນທີ່ຊຳລະຕົວຈິງ</div>
          {/* <div style={{ fontWeight: 'bold', fontSize: 20 }}>₭{numberFormat(convertPriceWithCommission(orderData?.totalPrice, orderData?.sumPriceBaht, orderData?.sumPriceUsd, taxPrice, shopRate))}</div> */}
          <div style={{ fontWeight: 'bold', fontSize: 20 }}>₭{sumPrice}</div>
        </div>

      </div>
      <div style={{ borderRadius: 10, width: '100%', padding: 10, background: "#fff", display: 'flex', gap: 10, justifyContent: 'center', alignItems: 'center' }}>
        {(!_.isEmpty(orderData?.dataConfirmCod) && orderData?.status !== "COMPLETED") ? <div style={{ display: 'flex', gap: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <p style={{ textAlign: 'center' }}>ອໍເດີ້ນີ້ຍັງບໍ່ຈ່າຍເງິນ ເນື່ອງຈາກວ່າເກັບປາຍທາງ</p>
        </div> : (
          <>
            {orderData?.paySlip ? <div style={{ borderRadius: 10, width: '100%', margin: '5px 0', padding: 10, background: '#FFF' }}>
              <div>
                <h4>ຮູບຊໍາລະ</h4>
              </div>
              <div style={{ width: '100%', padding: 5, border: '1px dashed #7777' }}>
                <img alt="" src={imageRender(orderData?.paySlip)} style={{ height: 'auto', width: '100%' }} />
              </div>
            </div> :
              <div className="d-flex justify-content-center align-items-center flex-column" style={{ overflow: 'hidden', paddingTop: 5, borderRadius: 10, width: '100%', background: '#FFF' }}>
                <p>ຊຳລະເງິນສຳເລັດແລ້ວ</p>
                <img src="https://app.bestportal.bri.co.id/img/greentick-unscreen.gif" style={{ width: "100%" }} />
              </div>}
          </>
        )}
      </div>

    </div>
  );
};

export default FinishOrder;
